


















































































import { Component, Prop, Vue } from "vue-property-decorator";
import CardOrderPenunjangIgd from "@/components/pemeriksaan/penunjang/CardOrderPenunjangIgd.vue";
import CardModalItemPenunjang from "@/components/modal/CardModalItemPenunjang.vue";
import { title } from "process";
import DataPenunjang from "@/services/DataPenunjang";
import { storePenunjang } from "@/store/modules/penunjang";
import { appModule } from "@/store/modules/app";
import { storeCopy } from "@/store/modules/copy";
// import CardPenunjangLain from "@/components/pemeriksaan/penunjang/CardPenunjangLain.vue";

@Component({
  components: {
    CardOrderPenunjangIgd,
    CardModalItemPenunjang
    // CardPenunjangLain
  }
})
export default class CardOrderPenunjangIgdGroup extends Vue {
  @Prop() sess_login!: object;
  @Prop() register!: string;
  @Prop() rm: string;
  tglIsi = new Date().toISOString().substr(0, 10);
  today = new Date().toISOString().substr(0, 10);
  tglShow = false;
  maxDate = new Date().toISOString().substr(0, 10);

  tab = "daftar-order";
  title = "";
  type = "";
  showModal = false;
  // orderItems = [];
  orderItemsLab = [];
  // groupItem = []
  orderItemsRadiologi = [];
  // groupItemRadiologi= []
  alertOpen = false;
  err: object = {};
  detailOrderLab = {};
  detailOrderRo = {};
  detailPenunjangLain = {};

  created() {
    storePenunjang.act_all_order_lab_by_reg(this.register);
    storePenunjang.act_all_order_radiologi_by_reg(this.register);
  }

  mounted() {
    const max = new Date(new Date().setDate(new Date().getDate() + 2));
    this.maxDate = max.toISOString().substring(0, 10);
    this.stateItemLab();
    this.stateItemRadiologi();
  }

  get statusPasteLab() {
    return storeCopy.copyLab;
  }

  get pasteLab() {
    return storeCopy.pastelab;
  }

  get statusPasteRo() {
    return storeCopy.copyRo;
  }

  get pasteRo() {
    return storeCopy.pastero;
  }

  stateItemLab() {
    storePenunjang.act_item_group_lab();
  }
  stateItemRadiologi() {
    storePenunjang.act_item_group_radiologi();
  }

  showItemModal(v) {}

  get stateorderlab() {
    return storePenunjang.listorderLab;
  }

  get stateorderradiologi() {
    return storePenunjang.listorderRadiologi;
  }
  get stateorderlabbyid() {
    return storePenunjang.orderLab;
  }
  get stateorderradiologibyid() {
    return storePenunjang.orderRadiologi;
  }

  getIdOrder(value) {
    if (value["type"] == "lab") {
      // window.setInterval(() => {
      // this.idOrderLab = this.stateorderlabbyid;
      this.detailOrderLab = value["detail"];
      // console.log("lab", this.detailOrderLab);
      // }, 500);
    } else if (value["type"] == "ro") {
      // this.idOrderRo = this.stateorderradiologibyid;
      this.detailOrderRo = value["detail"];
      // console.log("ro", this.detailOrderRo);
    } else {
      this.detailPenunjangLain = value["detail"];
    }
  }

  // showItemModal(v) {
  //   this.showModal = v;
  // }
  buatOrder() {
    this.tab = "buat-order";
  }
  // setOrderItems(items) { // untuk di list input
  //     this.orderItemsLab = items;
  // }
  setOrderItemsLab(items) {
    // untuk di list input
    // console.log('items ',items)
    this.orderItemsLab = items;
  }
  resetOrderItemsLab() {
    this.orderItemsLab = [];
  }
  setOrderItemsRadiologi(items) {
    // console.log(items);
    this.orderItemsRadiologi = items;
  }
  resetOrderItemsRadiologi() {
    this.orderItemsRadiologi = [];
  }
  alasanBatalLab(value) {
    const dt = DataPenunjang.cancelDataOrderLab(value["id"], value["alasan"]);
    dt.then(dt => {
      if (dt["data"]["status"] != 1) {
        // appModule.sendErrorAlert(dt["err"]);
        // console.log("gagal")
      } else {
        // console.log("sukses batal order lab");
        // console.log(dt);
        storePenunjang.act_all_order_lab_by_reg(this.register);
        appModule.NoticeDelay("Berhasil Membatalkan Order Laboratorium");
        // this.dialog = false;
      }
    });
    // console.log("lab ", value);
  }

  alasanBatalRad(value) {
    const dt = DataPenunjang.cancelDataOrderRadiologi(
      value["id"],
      value["alasan"]
    );
    dt.then(dt => {
      if (dt["data"]["status"] != 1) {
        // appModule.sendErrorAlert(dt["err"]);
        // console.log("gagal")
      } else {
        // console.log("sukses batal order radiologi");
        // console.log(dt);
        storePenunjang.act_all_order_radiologi_by_reg(this.register);
        appModule.NoticeDelay("Berhasil Membatalkan Order Radiologi");
        // this.dialog = false;
      }
    });
    // console.log("rad ", value);
  }

  showTab(value) {
    this.$emit("pageTab", value);
  }
}
